import Immutable from 'seamless-immutable';
import _ from 'lodash';
import RefData from 'ref-data';

import WinnerCollection from './winner-collection';
/**
 * WinnerHistory
 * @typedef {object} WinnerHistory
 * @property {string} action - the action that was taken RefData.Enum.ACTION.[DRAW|DRAW_PLACE].*
 * @property {object} config - only populated for certain events. Contains information about the selection of winners
 * @property {string} drawId - the id of the draw
 * @property {string} eventDate - the timestamp of the event
 * @property {WinnersCollection} winners
 * @property {number} id - the history id
 */

function create(winnerHistory = _defaultWinnerHistory) {
  const result = _.clone(winnerHistory);
  result.action = RefData.Model.hydrate(winnerHistory.action);
  //TODO winners when create called but not deserialize
  return Immutable(result, { prototype: model });
}

function deserialize(winnerHistory) {
  const result = _.pick(winnerHistory, _keys);
  result.winners = _.reduce(
    winnerHistory.data,
    (accWinners, winner) => {
      accWinners.push(winner.id);
      return accWinners;
    },
    []
  );
  result.modifiedBy = winnerHistory.user;
  result.lastUpdated = winnerHistory.eventDate;
  return create(result);
}

const model = {
  get showCriteria() {
    return (
      _.includes([RefData.Enum.ACTION.DRAW.SELECT, RefData.Enum.ACTION.DRAW.RESELECT], this.action.id) &&
      (_.get(this, 'config.candidatePool.criteria.length', 0) > 0 ||
        _.get(this, 'config.dateRange.from.length', 0) > 0 ||
        _.get(this, 'config.dateRange.to.length', 0) > 0)
    );
  },
};

const _keys = ['action', 'config', 'drawId', 'eventDate', 'id'];

const _defaultWinnerHistory = {};

export default {
  create,
  deserialize,
};
